module.exports = __webpack_public_path__ + "static/img/MT5.6cd2e53b.png";